import {toSi} from "@/app/utils/Format";

export default function(number) {
    return new Handlebars.SafeString(toSi(number));
}